import React, { Fragment, useEffect, useRef, useState } from 'react';
import "./login.scss";
import { Spinner } from '../../Loader/loader.js';
import { Snackbar } from '@mui/material';
import { userLogin, forgotPassword, resetPasswords } from '../../Redux/ActionCreators/authAction.js';
import { clearErrors } from '../../Redux/ActionCreators/errorAction.js';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import { useGoogleLogin } from '@react-oauth/google';


function Login() {
    const [defaultShowSignUp, setDefaultShowSignUp] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isResetPassword, setISResetPassword] = useState(false);
    const [resetPasswordComplete, setResetPasswordComplete] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [otpEmail, setOtpEmail] = useState('');
    const [isOtpEmailLoading, setIsOtpEmailLoading] = useState(false);
    const [otpEnable, setOtpEnable] = useState(false);
    const [emailOtpScreen, setEmailOtpScreen] = useState(true);
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [successEnable, setSuccessEnable] = useState(false);
    const [successMessageText, setSuccessMessageText] = useState('');
    const [responseStatus, setResponseStatus] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const autoSubmitRef = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const googleLoginRedirect = useGoogleLogin({
        flow: 'auth-code',
        ux_mode: 'redirect',
        redirect_uri: window.location.origin + '/auth/google/callback',
    });

    const error = useSelector(state => state.error)
    useEffect(() => {
        if (location.state?.googleError) {
            setSuccessEnable(true);
            setSuccessMessageText(location.state.googleError);
        }
    }, [location.state]);

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const authParam = params.get('auth');

        if (authParam === 'google' && !localStorage.getItem('token')) {
            localStorage.setItem('googleAuthSource', 'login');
            googleLoginRedirect();
            return;
        }

        if (authParam === 'linkedin' && !localStorage.getItem('token')) {
            localStorage.setItem('linkedInAuthSource', 'login');
            const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (authParam === 'microsoft' && !localStorage.getItem('token')) {
            localStorage.setItem('microsoftAuthSource', 'login');
            const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
            const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
            const scope = encodeURIComponent('openid profile email');
            window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
            return;
        }

        if (window.location.href.includes('otp')) {
            setDefaultShowSignUp(false);
            setOtp(window.location.search.split("=")[1]);
        }


        if (localStorage.getItem('token')) {
            const details = JSON.parse(localStorage.getItem("profileDetails"));
            if (details?.roleId === "1") {
                (window.location.pathname === '/' || window.location.pathname === '/login') && (
                    navigate('/users')
                )
            }
            else {
                (window.location.pathname === '/' || window.location.pathname === '/login') && (
                    navigate('/jobs')
                )
            }

        } else {
            window.location.pathname === '/' && (
                navigate('/login')
            )
        }

        // Prefill form from landing page popup (cross-subdomain cookie)
        const cookieMatch = document.cookie.match(/(?:^|;\s*)gappeo_login_prefill=([^;]*)/);
        if (cookieMatch) {
            try {
                const prefill = JSON.parse(decodeURIComponent(cookieMatch[1]));
                if (prefill.email) setEmail(prefill.email);
                if (prefill.password) setPassword(prefill.password);
                autoSubmitRef.current = !!(prefill.email && prefill.password);
            } catch (e) { /* ignore malformed data */ }
            // Delete the cookie immediately after reading
            document.cookie = 'gappeo_login_prefill=; domain=.gappeo.ai; path=/; max-age=0; SameSite=Lax; Secure';
        }

    }, [])

    // Auto-trigger login once prefill state has settled
    useEffect(() => {
        if (autoSubmitRef.current && email && password) {
            autoSubmitRef.current = false;
            loginUser();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [email, password]);


    const onEmailChange = (e) => {
        setEmailError('');
        setEmail(e.target.value);
    }

    const onChangePassword = (e) => {
        setPasswordError('');
        setPassword(e.target.value);
    }


    const loginUser = async () => {
        setIsLoading(true);
        setResponseStatus('')
        let emailvalue = email;
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailvalue) {
            setEmailError('Email cant be blank');
            setIsLoading(false);
            return false;
        }
        else if (!emailrex.test(String(emailvalue))) {
            setEmailError("Email is not valid");
            setIsLoading(false);
            return false;
        }
        else if (password === "") {
            setPasswordError('Please enter password');
            setIsLoading(false);
        }
        else {
            let login = {
                emailId: email,
                password: btoa(password.toString())
            }

            const res = await dispatch(userLogin(login));
            if (res?.type === 'LOGIN_USER') {
                setTimeout(() => {
                    const details = JSON.parse(localStorage.getItem("profileDetails"));
                    if (details?.roleId === "1") {
                        navigate('/users');
                    } else {
                        navigate('/jobs');
                    }
                }, 1000);
            } else {
                setSuccessEnable(true);
                setSuccessMessageText("Wrong email or password");
            }
            setTimeout(() => {
                if (error.successMessage === false) {
                    setIsLoading(false);
                }
            }, 1000);

        }
    }

    // const loginOnKeyPress = async (e) => {
    //     if (e.which === 13 || e.keyCode === 13) {
    //         setIsLoading(true);
    //         setResponseStatus('')
    //         let emailvalue = email;
    //         // eslint-disable-next-line no-useless-escape
    //         let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //         if (!emailvalue) {
    //             setEmailError('Email cant be blank');
    //             setIsLoading(false);
    //             return false;
    //         }
    //         else if (!emailrex.test(String(emailvalue))) {
    //             setEmailError("Email is not valid");
    //             setIsLoading(false);
    //             return false;
    //         }
    //         else if (password === "") {
    //             setPasswordError('Please enter password');
    //             setIsLoading(false);
    //         }
    //         else {
    //             let login = {
    //                 emailId: email,
    //                 password: btoa(password.toString())
    //             }

    //             const res = await dispatch(userLogin(login));
    //             if (res?.type === 'LOGIN_USER') {
    //                 setTimeout(() => {
    //                     const details = JSON.parse(localStorage.getItem("profileDetails"));
    //                     if (details?.roleId === "1") {
    //                         navigate('/users');
    //                     } else {
    //                         navigate('/jobs');
    //                     }
    //                 }, 1000);
    //             }
    //             localStorage.getItem('token') !== null ?
    //                 navigate('/jobs')
    //                 : navigate('/login')
    //             setTimeout(() => {
    //                 if (error.successMessage === false) {
    //                     setIsLoading(false);
    //                 }
    //             }, 1000);

    //         }
    //     }
    // }

    const resetPassword = () => {
        setISResetPassword(true);
        setEmailError('');
    }

    const handleChange = otp => setOtp(otp);

    const onOtpEmailChange = (e) => {
        setEmailError('');
        setOtpEmail(e.target.value);
    }

    const handleOtpEmail = async () => {
        // eslint-disable-next-line no-useless-escape
        let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!otpEmail) {
            setEmailError(`Email can't be blank`);
            return false;
        }
        else if (!emailrex.test(String(otpEmail))) {
            setEmailError("Email is not valid");
            return false;
        }
        else {
            setIsOtpEmailLoading(true);
            await dispatch(forgotPassword(otpEmail));
            localStorage.setItem('email', otpEmail);
            await setIsOtpEmailLoading(false);
            await setOtpEnable(true);
            await setEmailOtpScreen(false);

        }
    }


    const onOtpEmailChangeKeyPress = async (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (e.which === 13 || event.keyCode === 13) {
            // eslint-disable-next-line no-useless-escape
            let emailrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!otpEmail) {
                setEmailError('Email cant be blank');
                return false;
            }
            else if (!emailrex.test(String(otpEmail))) {
                setEmailError("Email is not valid");
                return false;
            }
            else {
                setIsOtpEmailLoading(true);
                await dispatch(forgotPassword(otpEmail));
                localStorage.setItem('email', otpEmail);
                await setIsOtpEmailLoading(false);
                await setOtpEnable(true);
                await setEmailOtpScreen(false);

            }
        }
    }

    const handleOtpCheck1 = async () => {
        if (newPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter new password");
        }
        else if (confirmNewPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter confirm password");
        }
        else if (newPassword !== confirmNewPassword) {
            setSuccessEnable(true);
            setSuccessMessageText("Password did not match");
        }
        else if (otp.length < 6) {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter all the code fields");
        }
        else {
            setIsOtpEmailLoading(true);

            let obj = {
                "emailId": localStorage.getItem('email'),
                "passWord": btoa(newPassword.toString()),
                "otp": otp
            }

            const res = await dispatch(resetPasswords(obj));
            if (res?.type === 'RESET_PASSWORD') {
                await setResetPasswordComplete(true);
                await setIsOtpEmailLoading(false);
            }
        }
    }

    const onPasswordChange = async (e) => {
        // eslint-disable-next-line no-restricted-globals
        if (e.which === 13 || event.keyCode === 13) {
            if (newPassword === "") {
                setSuccessEnable(true);
                setSuccessMessageText("Please enter new password");
            }
            else if (confirmNewPassword === "") {
                setSuccessEnable(true);
                setSuccessMessageText("Please enter confirm password");
            }
            else if (newPassword !== confirmNewPassword) {
                setSuccessEnable(true);
                setSuccessMessageText("Password did not match");
            }
            else {
                setIsOtpEmailLoading(true);
                let obj = {
                    otp: otp,
                    password: btoa(newPassword.toString())
                }
            }
        }
    }

    const handleOtpCheck = async () => {
        if (newPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter new password");
        }
        else if (confirmNewPassword === "") {
            setSuccessEnable(true);
            setSuccessMessageText("Please enter confirm password");
        }
        else if (newPassword !== confirmNewPassword) {
            setSuccessEnable(true);
            setSuccessMessageText("Password did not match");
        }

        else {
            setIsOtpEmailLoading(true);
            let obj = {
                otp: otp,
                password: newPassword
            }
            await setIsOtpEmailLoading(false);
        }
    }


    const handleGoogleClick = () => {
        localStorage.setItem('googleAuthSource', 'login');
        googleLoginRedirect();
    }

    const handleLinkedInClick = () => {
        localStorage.setItem('linkedInAuthSource', 'login');
        const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/linkedin/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    }

    const handleMicrosoftClick = () => {
        localStorage.setItem('microsoftAuthSource', 'login');
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = encodeURIComponent(window.location.origin + '/auth/microsoft/callback');
        const scope = encodeURIComponent('openid profile email');
        window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;
    }

    const redirectTologin = () => {
        window.location.reload()
    }




    const snackClosed = () => {
        dispatch(clearErrors());
        setSuccessEnable(false);
        setSuccessMessageText('')
    }

    const domainDetail = JSON.parse(localStorage.getItem('domainDetails'));

    return (
        <Fragment>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successMessage}
                onClose={() => snackClosed()}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={error.successEnable}
                onClose={() => snackClosed()}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="success" sx={{ width: '100%' }}>
                    {error.successMessageText}
                </Alert>
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={successEnable}
                onClose={() => snackClosed()}
                autoHideDuration={4000}
            >
                <Alert onClose={snackClosed} severity="error" sx={{ width: '100%' }}>
                    {successMessageText}
                </Alert>
            </Snackbar>

            <div className="login-page">
                {defaultShowSignUp ? (
                    <div className="login-card-wrapper">
                        <div className="login-card">
                            {isLoading && (
                                <div style={{ position: 'absolute', inset: 0, borderRadius: 20, background: '#181A1F', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10 }}>
                                    <Spinner size={40} />
                                </div>
                            )}
                            <div
                                title={domainDetail !== null ? domainDetail?.displayName : 'Gappeo'}
                                style={{ backgroundImage: `url(${domainDetail !== null ? domainDetail?.logoImage : '/images/gappeoai-logo.png'})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 40, marginBottom: 20 }}
                            />

                            {isResetPassword === false ? (
                                <Fragment>
                                    <h2>{`Welcome to ${domainDetail !== null ? domainDetail?.tenantName : 'Gappeo'}`}</h2>

                                    <button onClick={handleGoogleClick} disabled={isLoading} className="social-btn">
                                        <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
                                        Continue with Google
                                    </button>
                                    <button onClick={handleLinkedInClick} disabled={isLoading} className="social-btn">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#0077B5"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                                        Continue with LinkedIn
                                    </button>
                                    <button onClick={handleMicrosoftClick} disabled={isLoading} className="social-btn">
                                        <svg width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="9" height="9" fill="#F25022"/><rect x="11" y="1" width="9" height="9" fill="#7FBA00"/><rect x="1" y="11" width="9" height="9" fill="#00A4EF"/><rect x="11" y="11" width="9" height="9" fill="#FFB900"/></svg>
                                        Continue with Microsoft
                                    </button>

                                    <div className="or-divider-row">
                                        <hr /><span>or continue with email</span><hr />
                                    </div>

                                    {responseStatus && (
                                        <span style={{ fontWeight: 600, color: 'red', fontSize: 14, display: 'block', marginBottom: 8 }}>{responseStatus}</span>
                                    )}

                                    <div className="form-group">
                                        <div className="input-icon-wrapper">
                                            <span className="input-icon-left">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                                            </span>
                                            <input type="email" className="form-control" placeholder="Work email address" value={email} onChange={onEmailChange} />
                                        </div>
                                        <div className='error'>{emailError}</div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-icon-wrapper has-eye">
                                            <span className="input-icon-left">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                            </span>
                                            <input type={showPassword ? "text" : "password"} className="form-control" placeholder="Password" value={password} onChange={onChangePassword} />
                                            <span className="input-icon-right" onClick={() => setShowPassword(p => !p)}>
                                                {showPassword ? (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                                ) : (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                                )}
                                            </span>
                                        </div>
                                        <div className='error'>{passwordError}</div>
                                    </div>

                                    <button onClick={loginUser} disabled={isLoading} className="login-button">
                                        LOGIN
                                    </button>

                                    <h2 className="forgot-btn" onClick={resetPassword}>Forgot Password?</h2>
                                    {/* <p>New user? <span className="login-link" onClick={() => navigate('/signup')}>Sign up free</span></p> */}
                                </Fragment>
                            ) : (
                                <div style={{ width: '100%' }}>
                                    <h3>Reset your password</h3>
                                    {otpEnable === false && emailOtpScreen ? (
                                        <Fragment>
                                            <p style={{ color: '#9CA3AF', fontSize: 14, textAlign: 'center', marginTop: 8 }}>Please enter your registered email address.</p>
                                            <div className="form-group mt-3">
                                                <input type="email" className="form-control" placeholder="Email" onChange={onOtpEmailChange} value={otpEmail} />
                                            </div>
                                            <div className='error'>{emailError}</div>
                                            <button onClick={handleOtpEmail} className="login-button mt-2">
                                                {isOtpEmailLoading ? <Spinner /> : 'CONTINUE'}
                                            </button>
                                        </Fragment>
                                    ) : resetPasswordComplete === false ? (
                                        <div className="mt-3">
                                            <p style={{ color: '#9CA3AF', fontSize: 14, textAlign: 'center' }}>Please enter the code sent to your email.</p>
                                            <div className="form-group mt-2">
                                                <input type="text" placeholder="Enter OTP" className="form-control mb-2" autoComplete="off" onChange={(e) => handleChange(e.target.value)} />
                                                <div className="input-icon-wrapper has-eye mb-2">
                                                    <span className="input-icon-left">
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                                    </span>
                                                    <input type={showNewPassword ? "text" : "password"} placeholder="New password" className="form-control" autoComplete="off" onChange={(e) => setNewPassword(e.target.value)} />
                                                    <span className="input-icon-right" onClick={() => setShowNewPassword(p => !p)}>
                                                        {showNewPassword ? (
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                                        ) : (
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                                        )}
                                                    </span>
                                                </div>
                                                <div className="input-icon-wrapper has-eye">
                                                    <span className="input-icon-left">
                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                                    </span>
                                                    <input type={showConfirmPassword ? "text" : "password"} placeholder="Confirm new password" className="form-control" onChange={(e) => setConfirmNewPassword(e.target.value)} />
                                                    <span className="input-icon-right" onClick={() => setShowConfirmPassword(p => !p)}>
                                                        {showConfirmPassword ? (
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                                        ) : (
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <button disabled={isOtpEmailLoading} onClick={handleOtpCheck1} className="login-button mt-2">
                                                {isOtpEmailLoading ? <Spinner /> : 'Reset'}
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="mt-3 text-center">
                                            <p style={{ color: '#9CA3AF', fontSize: 14 }}>Password has been successfully changed.</p>
                                            <button onClick={redirectTologin} className="login-button mt-2">Login</button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="login-card-wrapper">
                        <div className="login-card">
                            <h3>Set your password</h3>
                            <div className="mt-3">
                                <input className='form-control d-none' onChange={(e) => handleChange(e.target.value)} value={otp} />
                                <div className="form-group mt-3">
                                    <div className="input-icon-wrapper has-eye mb-2">
                                        <span className="input-icon-left">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                        </span>
                                        <input type={showNewPassword ? "text" : "password"} placeholder="New password" className="form-control" onChange={(e) => setNewPassword(e.target.value)} />
                                        <span className="input-icon-right" onClick={() => setShowNewPassword(p => !p)}>
                                            {showNewPassword ? (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                            ) : (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                            )}
                                        </span>
                                    </div>
                                    <div className="input-icon-wrapper has-eye">
                                        <span className="input-icon-left">
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                                        </span>
                                        <input type={showConfirmPassword ? "text" : "password"} placeholder="Confirm new password" className="form-control" onChange={(e) => setConfirmNewPassword(e.target.value)} />
                                        <span className="input-icon-right" onClick={() => setShowConfirmPassword(p => !p)}>
                                            {showConfirmPassword ? (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                                            ) : (
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                                            )}
                                        </span>
                                    </div>
                                </div>
                                <button disabled={isOtpEmailLoading !== false} onClick={handleOtpCheck} className="login-button mt-2">
                                    {isOtpEmailLoading ? <Spinner /> : 'Set'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    )
}


export default Login;